// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout-module--container--2Cr5M","skipToMain":"MainLayout-module--skipToMain--2u4Up"};